import React, { useEffect, useRef, useState } from "react";
import CustomerList, { ListOptions } from "./CustomerList";
import { DEFAULT_LIST_SORT } from "../../listSort";
import CustomerEdit from "./CustomerEdit";
import { MDSplitView } from "@solsys/solsys-reactjs";

export default function CustomerController({
  navigate,
  action,
  id,
  search,
  style,
  options = {},
}) {
  let listState = {
    [ListOptions.sortBy]: DEFAULT_LIST_SORT.sortBy,
    [ListOptions.sortDirection]: DEFAULT_LIST_SORT.sortDirection,
    [ListOptions.name]: null,
  };
  const didMount = useRef(false);
  useEffect(() => (didMount.current ? undefined : (didMount.current = true)));
  if (!didMount.current && Object.keys(search).length) {
    Object.keys(ListOptions).forEach((key) => {
      listState[key] = search[key];
    });
  }

  listState = useState(listState);

  return (
    <div className="customers">
      <MDSplitView
        globalName="CustomerMDV"
        style={style}
        action={action}
        master={({ isNarrow, autoSelect }) => (
          <CustomerList
            isMaster
            state={listState}
            id={id}
            action={action}
            onStateChange={(state) => {
              navigate({
                action,
                id,
                search: state,
                push: false,
              });
            }}
            onSelect={(newId, userInteraction) => {
              if (
                newId &&
                id &&
                String(newId) === String(id) &&
                userInteraction
              ) {
                navigate({
                  popOut: isNarrow,
                  action: "list",
                  id: null,
                  search: listState[0],
                });
              } else {
                navigate({
                  popOut: isNarrow,
                  ...(newId === 0
                    ? {
                        action: "add",
                        id: null,
                      }
                    : {
                        action: "edit",
                        id: newId,
                      }),
                  search: listState[0],
                });
              }
            }}
          />
        )}
        detail={() => (
          <CustomerEdit
            key={`action_${action}_id_${id}`}
            id={id}
            action={action}
            navigate={navigate}
          />
        )}
        initialWidth={300}
        maxWidth={800}
        minWidth={290}
      />
    </div>
  );
}
